// This file is auto-generated by dibs-icons script
import { FC } from 'react';

type Article20CircleFilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Article20CircleFilled: FC<Article20CircleFilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M13.714 15.429H8.571v-1.286h5.143v1.286ZM15.429 12.643H8.57v-1.286h6.858v1.286ZM15.429 9.857H8.57V8.571h6.858v1.286Z" />
            <path
                d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Zm-5.622-6.378c.251.252.554.378.908.378h9.428c.354 0 .657-.126.908-.378.252-.252.378-.554.378-.908V7.286c0-.354-.126-.657-.378-.908A1.238 1.238 0 0 0 16.714 6H7.286c-.354 0-.657.126-.908.378A1.238 1.238 0 0 0 6 7.286v9.428c0 .354.126.657.378.908Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Article20CircleFilled;
